import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { APP_PATHS } from "@/app/shared/constants";
import { buildAbsoluteRoute } from "@/app/shared/utils/absolute-route.util";
import { AuthService } from "./auth.service";

const ENTREPOT_EMAIL = "entrepot@prozon.com";

@Injectable({
  providedIn: "root",
})
/**
 * Service that handles post-login redirections based on user identity.
 * Currently redirects entrepot@prozon.com to the warehouse orders page.
 */
export class PostLoginRedirectService {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  /**
   * Checks the authenticated user's email and redirects to the appropriate
   * page if needed. Only redirects when the user is on the home page.
   *
   * @param {string} currentPath - The current URL pathname.
   */
  handleRedirect(currentPath: string): void {
    const email = this.authService.getIAMUserInfo().email;
    const isOnHomePage = currentPath === "/" || currentPath === "";

    if (email === ENTREPOT_EMAIL && isOnHomePage) {
      this.router.navigateByUrl(buildAbsoluteRoute(APP_PATHS.orders));
    }
  }
}
